import clsx from 'clsx';
import { Base, Text } from '../../../components/Base';
import { SrOnly } from '../../../components/Helper';
import { StatusIcon } from '../../../components/Private';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "ListStatus-root_2IfZI Widget-widgetFixedHeight_2GNLw",
  "icon": "ListStatus-icon_21aqX",
  "bordered": "ListStatus-bordered_IDfDX",
  "intentInfo": "ListStatus-intentInfo_TcV0s",
  "intentSuccess": "ListStatus-intentSuccess_26DgW",
  "intentWarning": "ListStatus-intentWarning_2-869",
  "intentDanger": "ListStatus-intentDanger_1IEWO",
  "intentProgress": "ListStatus-intentProgress_1VNqR",
  "intentUnknown": "ListStatus-intentUnknown_1HBBs"
};
function ListStatus({
  intent: intentProp = 'info',
  theme = 'info',
  variant = 'default',
  a11yLabel,
  className,
  ...extraProps
}) {
  const intent = theme !== 'info' ? theme : intentProp;
  const rootClasses = clsx(styles.root, {
    [styles.bordered]: variant === 'bordered',
    [styles.intentInfo]: intent === 'info',
    [styles.intentSuccess]: intent === 'success',
    [styles.intentWarning]: intent === 'warning',
    [styles.intentDanger]: intent === 'danger',
    [styles.intentProgress]: intent === 'progress',
    [styles.intentUnknown]: intent === 'unknown'
  }, className);
  return /*#__PURE__*/_jsxs(Base, {
    flex: true,
    flexAlignItemsCenter: true,
    paddingLeft: variant === 'compact' ? null : 'small',
    paddingRight: "xsmall",
    className: rootClasses,
    ...extraProps,
    children: [/*#__PURE__*/_jsx(StatusIcon, {
      intent: intent,
      className: styles.icon
    }), a11yLabel && /*#__PURE__*/_jsx(Text, {
      select: "none",
      component: /*#__PURE__*/_jsx(SrOnly, {
        children: a11yLabel
      })
    })]
  });
}
export default ListStatus;